import { Close as CloseIcon } from '@mui/icons-material';
import { Button, Dialog, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material';
import { type ReactElement } from 'react';

interface UnsavedChangesDialogProps {
  open: boolean;
  isSaving: boolean;
  onSaveAndLeave: () => void;
  onLeaveWithoutSaving: () => void;
  onCancel: () => void;
}

// Guards the editors' back button: leaving drops unsaved form data, so the choice is explicit.
export function UnsavedChangesDialog({
  open,
  isSaving,
  onSaveAndLeave,
  onLeaveWithoutSaving,
  onCancel,
}: UnsavedChangesDialogProps): ReactElement {
  return (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
      <DialogTitle className="vtwo:flex vtwo:items-center vtwo:justify-between vtwo:pb-2">
        <Typography variant="body2" className="vtwo:font-bold">
          Confirmation
        </Typography>
        <IconButton size="small" onClick={onCancel} aria-label="Close">
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent className="vtwo:flex vtwo:flex-col vtwo:gap-4 vtwo:pb-6">
        <Typography variant="h6" className="vtwo:font-bold vtwo:text-typography-primary">
          You have unsaved changes
        </Typography>
        <Button
          variant="contained"
          disableElevation
          disabled={isSaving}
          onClick={onSaveAndLeave}
          className="vtwo:bg-[#1F8A5F]! vtwo:text-white! vtwo:hover:bg-[#19714E]! vtwo:rounded-lg!"
        >
          {isSaving ? 'Saving…' : 'Save and leave'}
        </Button>
        <Button
          variant="outlined"
          disabled={isSaving}
          onClick={onLeaveWithoutSaving}
          className="vtwo:text-typography-primary! vtwo:border-plus-border! vtwo:rounded-lg!"
        >
          Leave without saving
        </Button>
        <Button
          variant="outlined"
          disabled={isSaving}
          onClick={onCancel}
          className="vtwo:text-typography-primary! vtwo:border-plus-border! vtwo:rounded-lg!"
        >
          Cancel
        </Button>
      </DialogContent>
    </Dialog>
  );
}
